import type { FiltersConfig } from '@rocco/ui/filter-sort/types/filter-config-section';

/**
Project filters configuration
Note: The order of filters in this configuration is important because it determines the sequence in which filters are applied and displayed.
This can affect both the user interface and the logic that processes these filters.
 **/
export const PROJECT_FILTERS_CONFIG: FiltersConfig = {
    resultName: 'Project',
    barFilters: [
        {
            title: 'Professionals',
            minContentWidth: 20,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggProfessionals',
                    filterKey: 'professionals',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                },
            ],
        },
        {
            title: 'Interactive',
            filters: [
                {
                    type: 'default',
                    filterKey: 'hasProducts',
                    hideWhenEmpty: true,
                    label: 'Projects with products',
                },
                {
                    type: 'default',
                    filterKey: 'hasVideos',
                    hideWhenEmpty: true,
                    label: 'Projects with videos',
                },
                {
                    type: 'default',
                    filterKey: 'hasAwards',
                    label: 'Award winning Projects',
                    hideWhenEmpty: true,
                },
                {
                    type: 'default',
                    filterKey: 'projectOfTheMonth',
                    label: 'Project of the month',
                    hideWhenEmpty: true,
                },
            ],
        },
    ],

    modalFilters: [
        {
            title: 'Interactive',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'hasProducts',
                    label: 'Projects with Products',
                },
                {
                    type: 'default',
                    filterKey: 'hasVideos',
                    label: 'Projects with Videos',
                },
            ],
        },
        {
            title: 'Featured',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'projectOfTheMonth',
                    label: 'Project of the Month',
                },
                {
                    type: 'default',
                    filterKey: 'hasAwards',
                    label: 'Award Winning Project',
                },
            ],
        },
        {
            title: 'Must include these professional types',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'multiple',
                    columns: 1,
                    filterKey: 'professionalCategories',
                },
            ],
        },
        {
            title: 'Services used',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggProfessions',
                    filterKey: 'professions',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                    columns: 1,
                },
            ],
        },
        {
            title: 'Professionals',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'searchable',
                    aggregationProperty: 'aggProfessionals',
                    filterKey: 'professionals',
                    searchInputPlaceholder: 'Search by Name',
                    allowMultipleValues: true,
                    allowAlphabeticalGrouping: true,
                    columns: 1,
                },
            ],
        },
        {
            title: 'Staff admin filters',
            collapsable: true,
            collapsedByDefault: true,
            adminOnly: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'noCategory',
                    label: 'Uncategorised',
                },
                {
                    type: 'default',
                    filterKey: 'profileOnly',
                    label: 'Newly created',
                },
            ],
        },
    ],
};
